export default __webpack_public_path__ + "static/media/hero.bf755691.png";